/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Answer_SectionsInputs */

const en_faq_answer_sections = /** @type {(inputs: Faq_Answer_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just uncheck the checkboxes for the sections you want to skip!`)
};

const es_faq_answer_sections = /** @type {(inputs: Faq_Answer_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Solo desmarca las casillas de las secciones que quieras omitir!`)
};

/**
* | output |
* | --- |
* | "Just uncheck the checkboxes for the sections you want to skip!" |
*
* @param {Faq_Answer_SectionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const faq_answer_sections = /** @type {((inputs?: Faq_Answer_SectionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Answer_SectionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_faq_answer_sections(inputs)
	return en_faq_answer_sections(inputs)
});